var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multi-cards',{staticClass:"contract__content__cards",attrs:{"status":"active"}}),(_vm.showTransactions)?_c('loan-transactions',{attrs:{"hideEmptyView":true,"visibleTransactionsCount":3,"showHistoryButton":{
      to: { name: 'loan-transactions' },
      label: _vm.translations.showHistory
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }